import { MutationTuple, gql, useMutation } from '@apollo/client';

const SEND_RESET_PASSWORD_MUTATION = gql`
  mutation sendPasswordResetEmail($details: ApiResetPasswordEmailInput!) {
    sendPasswordResetEmail(details: $details) {
      message
    }
  }
`;

interface PasswordResetInput {
  details: {
    email: string;
  };
}

interface PasswordResetOutput {
  sendPasswordResetEmail: {
    message: string;
  };
}

function usePasswordResetMutation(): MutationTuple<
  PasswordResetOutput,
  PasswordResetInput
> {
  return useMutation<PasswordResetOutput, PasswordResetInput>(
    SEND_RESET_PASSWORD_MUTATION,
  );
}

export type { PasswordResetOutput };
export { usePasswordResetMutation };
